import React from "react";
import { Icon } from "../Icon";

const TONES = {
  success: {
    bg: "var(--kr-status-success-bg)",
    fg: "var(--kr-status-success-fg)",
    border: "var(--kr-success-100)",
    icon: "CheckCircle2",
  },
  warning: {
    bg: "var(--kr-status-warning-bg)",
    fg: "var(--kr-status-warning-fg)",
    border: "var(--kr-warning-100)",
    icon: "AlertTriangle",
  },
  danger: {
    bg: "var(--kr-status-danger-bg)",
    fg: "var(--kr-status-danger-fg)",
    border: "var(--kr-danger-100)",
    icon: "XCircle",
  },
  info: {
    bg: "var(--kr-status-info-bg)",
    fg: "var(--kr-status-info-fg)",
    border: "var(--kr-info-100)",
    icon: "Info",
  },
  neutral: {
    bg: "var(--kr-bg-subtle)",
    fg: "var(--kr-fg-strong)",
    border: "var(--kr-border)",
    icon: "Info",
  },
};

export function Alert({ tone = "info", title, children, onClose, action, icon, style }) {
  const t = TONES[tone] || TONES.info;
  return (
    <div
      role="alert"
      style={{
        display: "flex",
        gap: 12,
        background: t.bg,
        color: t.fg,
        border: `1px solid ${t.border}`,
        borderRadius: "var(--kr-radius-md)",
        padding: "12px 14px",
        fontSize: 13,
        lineHeight: 1.5,
        alignItems: "flex-start",
        ...(style || {}),
      }}
    >
      <Icon name={icon || t.icon} size={18} style={{ marginTop: 1, flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && (
          <div style={{ fontWeight: 600, marginBottom: children ? 2 : 0 }}>
            {title}
          </div>
        )}
        {children && <div style={{ color: t.fg }}>{children}</div>}
        {action && <div style={{ marginTop: 8 }}>{action}</div>}
      </div>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Cerrar"
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: "currentColor",
            padding: 2,
            opacity: 0.7,
          }}
        >
          <Icon name="X" size={16} />
        </button>
      )}
    </div>
  );
}

export default Alert;
